export default {"src":"/_next/static/media/saving.d98cd60e.svg","height":31,"width":32};